export const dataNuestras_voces = [
  // ===== VIDEOS DRIVE =====
  
  {
    id: 2,
    tipo: "YUYE",
    iframeURL:
      "https://www.youtube.com/embed/tm101fBrRGw?si=Pq_n2Zqu_Arej6Lc",
    alt: "Video YUYE",
    grupo: 1,
  },

  {
    id: 1,
    tipo: "YOLOTL",
    iframeURL:
      "https://www.youtube.com/embed/kN5MuDotYL8?si=pRClM-T3Nzq7pf0a",
    alt: "Video YOLOTL",
    grupo: 1,
  },

  {
    id: 3,
    tipo: "MARICRUZ",
    iframeURL:
      "https://www.youtube.com/embed/OaBPP6930go?si=JvQ-V3GN1tBrbFCJ",
    alt: "Video MARICRUZ",
    grupo: 1,
  },
];